import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TableProperty, Tbody, Thead} from '../../../user/model/TableProperty';

@Component({
  selector: 'app-add-table-property',
  templateUrl: './add-table-property.component.html',
  styleUrls: ['./add-table-property.component.css']
})
export class AddTablePropertyComponent implements OnInit {
  @Input() tableProperty: TableProperty;
  thead: Thead;
  tbody: Tbody;
  @Input() element: any;
  public color = 'rgba(0,0,0,1)';
  @Output() saveTableProperty = new EventEmitter<string>();
  // @Input() events: Observable<void>;

  constructor() {
  }

  ngOnInit(): void {
    this.thead = this.tableProperty.thead;
    this.tbody = this.tableProperty.tbody;
  }

  colorPickerChangeThead(thead: Thead, rgbColor: string, background) {
    if (background === 'background') {
      thead.backgroundColor = rgbColor;
    } else {
      thead.color = rgbColor;
    }
    return thead;
  }

  colorPickerChangeTbody(tbody: Tbody, rgbColor: string, background) {
    if (background === 'background') {
      tbody.backgroundColor = rgbColor;
    } else {
      tbody.color = rgbColor;
    }
    return tbody;
  }

  accept() {
    // @ts-ignore
    this.saveTableProperty.emit(this.tableProperty);
  }

  get lineHeights() {
    return ['auto', '0px', '5px', '10px', '15px', '20px', '25px', '30px'];
  }
}
